/*************** This is the default store data when creating a new store ****************/

// TODO: make a config file update API that fetch all essential data from protocol
const sdkConfigDefaultData = {
    "DomainSuffix": [
        "ol"
    ]
};

module.exports = {
    sdkConfigDefaultData
};

